import { render, staticRenderFns } from "./NewsBar.vue?vue&type=template&id=564e20b1&scoped=true&"
import script from "./NewsBar.vue?vue&type=script&lang=js&"
export * from "./NewsBar.vue?vue&type=script&lang=js&"
import style0 from "./NewsBar.vue?vue&type=style&index=0&id=564e20b1&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e20b1",
  null
  
)

export default component.exports